import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    deactivateCityLineAPI,
    deleteCityZoneAPI,
    getCityLinesAPI,
    getCityZonesAPI,
    insertCityLineAPI,
    insertCityZoneAPI,
    updateCityLineAPI,
    updateCityZoneAPI
} from "../../api/city";

function serverMessage(error, fallback) {
    const data = error?.response?.data;
    if (data?.code && data?.message) {
        return data.message;
    }
    if (data?.details?.length) {
        return data.details.join(" ");
    }
    return data?.message || data?.error || fallback;
}

export const fetchCityZones = createAsyncThunk("city/fetchZones",
    async (onlyActive, {rejectWithValue}) => {
        try {
            const response = await getCityZonesAPI(onlyActive);
            return response.data;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri učitavanju zona."));
        }
    });

export const saveCityZone = createAsyncThunk("city/saveZone",
    async ({id, payload}, {rejectWithValue}) => {
        try {
            const response = id ? await updateCityZoneAPI(id, payload) : await insertCityZoneAPI(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri čuvanju zone."));
        }
    });

export const removeCityZone = createAsyncThunk("city/removeZone",
    async (id, {rejectWithValue}) => {
        try {
            await deleteCityZoneAPI(id);
            return id;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri brisanju zone."));
        }
    });

export const fetchCityLines = createAsyncThunk("city/fetchLines",
    async (unused, {rejectWithValue}) => {
        try {
            const response = await getCityLinesAPI();
            return response.data;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri učitavanju gradskih linija."));
        }
    });

export const saveCityLine = createAsyncThunk("city/saveLine",
    async ({id, payload}, {rejectWithValue}) => {
        try {
            const response = id ? await updateCityLineAPI(id, payload) : await insertCityLineAPI(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri čuvanju gradske linije."));
        }
    });

export const deactivateCityLine = createAsyncThunk("city/deactivateLine",
    async (id, {rejectWithValue}) => {
        try {
            await deactivateCityLineAPI(id);
            return id;
        } catch (error) {
            return rejectWithValue(serverMessage(error, "Greška pri gašenju gradske linije."));
        }
    });

const initialState = {
    zones: [],
    zonesLoading: false,
    lines: [],
    linesLoading: false
};

const citySlice = createSlice({
    name: "city",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCityZones.pending, (state) => {
                state.zonesLoading = true;
            })
            .addCase(fetchCityZones.fulfilled, (state, {payload}) => {
                state.zonesLoading = false;
                state.zones = payload || [];
            })
            .addCase(fetchCityZones.rejected, (state) => {
                state.zonesLoading = false;
            })
            .addCase(fetchCityLines.pending, (state) => {
                state.linesLoading = true;
            })
            .addCase(fetchCityLines.fulfilled, (state, {payload}) => {
                state.linesLoading = false;
                state.lines = payload || [];
            })
            .addCase(fetchCityLines.rejected, (state) => {
                state.linesLoading = false;
            });
    }
});

export const cityReducer = citySlice.reducer;
